import { Epic, ofType } from "redux-observable";
import { catchError, map, mergeMap, switchMap } from "rxjs/operators";
import { BadgesActionsTypes } from "./badgesTypes";
import {
  createBadgesFailed,
  createBadgesSuccess,
  deleteBadgeFailed,
  deleteBadgeSuccess,
  getBadgesDataFailed,
  getBadgesDataSuccess,
} from "./badgesActions";
import { from, of } from "rxjs";
import dataService from "../../services/dataService";
import { hideScreenLoaderAction } from "../loader/loaderActions";
import { showNotification } from "../notification/notificationActions";

export const getBadgesTableDataEpic: Epic = (action$: any, state$: any) => {
  return action$.pipe(
    ofType(BadgesActionsTypes.GET_BADGES_DATA),
    switchMap((action: any): any => {
      const param = action?.payload.param;
      const searchValue = action?.payload.searchValue;
      const size = action?.payload.size;
      const page = action?.payload.page;
      return from(
        dataService.getBadgesList(param, searchValue, page, size)
      ).pipe(
        map((response?: any) => {
          return getBadgesDataSuccess(response?.response);
        }),
        catchError((error) =>
          of(
            getBadgesDataFailed(error),
            showNotification(
              "badgesList.loadingError",
              "error",
              error.response?.message || error?.response?.details?.message,
              error?.status
            )
          )
        )
      );
    })
  );
};

export const deleteBadgeEpic: Epic = (action$: any, state$: any) => {
  return action$.pipe(
    ofType(BadgesActionsTypes.DELETE_BADGE),
    switchMap((action: any): any => {
      const bagdeId = action.payload.badgeId;
      return from(dataService.deleteBadge(bagdeId)).pipe(
        mergeMap(() => {
          return of(
            showNotification("badgesList.deleteSuccess", "success", ""),
            deleteBadgeSuccess(),
            hideScreenLoaderAction()
          );
        }),
        catchError((error) =>
          of(
            deleteBadgeFailed(),
            hideScreenLoaderAction(),
            showNotification(
              "badgesList.deleteError",
              "error",
              error.response?.message || error?.response?.details?.message,
              error?.status
            )
          )
        )
      );
    })
  );
};

export const createBadgesEpic: Epic = (action$: any, state$: any) => {
  return action$.pipe(
    ofType(BadgesActionsTypes.CREATE_BADGES),
    switchMap((action: any): any => {
      const { campaignName, file } = action.payload;
      return from(dataService.createBadges(campaignName, file)).pipe(
        mergeMap((response?: any) => {
          return response?.response?.badgesCreated?.length
            ? of(
                createBadgesSuccess(response?.response),
                hideScreenLoaderAction(),
                showNotification("badgesList.successCreate", "success", "")
              )
            : of(
                createBadgesSuccess(response?.response),
                hideScreenLoaderAction()
              );
        }),
        catchError((error) =>
          of(
            createBadgesFailed(),
            hideScreenLoaderAction(),
            showNotification(
              "badgesList.createError",
              "error",
              error.response?.message || error?.response?.details?.message,
              error?.status
            )
          )
        )
      );
    })
  );
};
